(function () {
  'use strict';

  var state = {
    product: null,
    currentVariantId: null,
    loading: false
  };

  function normalize(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\b(sin stock|agotado|sold out|out of stock)\b/gi, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function productJsonFromPage() {
    var el = document.querySelector('[data-section-type="product"] [data-product-json], [id^="mg-woowax-"] [data-product-json], [id^="mg-watershield-"] [data-product-json], [id^="mg-activo-"] [data-product-json], [id^="mg-nova-"] [data-product-json], [data-product-json]');
    if (!el) return null;
    try {
      var data = JSON.parse(el.textContent || el.innerHTML || '{}');
      return data.product || data;
    } catch (e) {
      return null;
    }
  }

  function loadProduct() {
    if (state.product || state.loading) return Promise.resolve(state.product);
    state.loading = true;

    var inline = productJsonFromPage();
    if (inline && Array.isArray(inline.variants)) {
      state.product = inline;
      state.loading = false;
      return Promise.resolve(state.product);
    }

    var path = window.location.pathname.replace(/\/$/, '');
    if (!/\/products\//.test(path)) {
      state.loading = false;
      return Promise.resolve(null);
    }

    return fetch(path + '.js', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('product json');
        return response.json();
      })
      .then(function (product) {
        state.product = product;
        return product;
      })
      .catch(function () { return null; })
      .finally(function () { state.loading = false; });
  }

  function pumperContainer(node) {
    if (!node || !node.closest) return null;
    return node.closest('.prvw_block, [class*="prvw_"], .order-value-booster-block, [data-pumper-native-host], [data-pumper-app-slot]');
  }

  function selectedOption(select) {
    if (!select || typeof select.selectedIndex !== 'number') return null;
    return select.options[select.selectedIndex] || null;
  }

  function numericCandidates(select, option) {
    var values = [];
    [
      select && select.value,
      option && option.value,
      option && option.getAttribute('data-variant-id'),
      option && option.getAttribute('data-variant'),
      option && option.getAttribute('data-id')
    ].forEach(function (value) {
      var match = String(value || '').match(/\b\d{8,}\b/);
      if (match) values.push(match[0]);
    });
    return values;
  }

  function findVariant(select, product) {
    if (!product || !Array.isArray(product.variants)) return null;
    var option = selectedOption(select);
    if (!option) return null;

    var ids = numericCandidates(select, option);
    for (var i = 0; i < ids.length; i++) {
      var byId = product.variants.find(function (variant) {
        return String(variant.id) === String(ids[i]);
      });
      if (byId) return byId;
    }

    var wanted = [normalize(select.value), normalize(option.textContent)].filter(Boolean);
    var matches = product.variants.filter(function (variant) {
      var title = normalize(variant.title);
      var opts = [variant.option1, variant.option2, variant.option3].filter(Boolean).map(normalize);
      return wanted.some(function (value) {
        return title === value || opts.indexOf(value) !== -1;
      });
    });

    if (!matches.length) return null;
    return matches.find(function (variant) {
      return variant.available !== false && (variant.featured_media || variant.featured_image);
    }) || matches.find(function (variant) { return variant.available !== false; }) || matches[0];
  }

  function mediaIdForVariant(variant) {
    if (!variant) return null;
    if (variant.featured_media && variant.featured_media.id) return String(variant.featured_media.id);
    if (variant.featured_image && variant.featured_image.id) return String(variant.featured_image.id);
    return null;
  }

  function imageUrlForVariant(variant) {
    if (!variant) return '';
    var image = variant.featured_image || (variant.featured_media && (variant.featured_media.preview_image || variant.featured_media));
    if (!image) return '';
    return String(image.src || image.url || '');
  }

  function productSectionRoot() {
    return document.querySelector('[data-section-type="product"]');
  }

  function emitThemeVariantChanged(variant) {
    var root = productSectionRoot();
    if (!root || !variant) return false;
    var previous = null;
    if (state.product && Array.isArray(state.product.variants) && state.currentVariantId) {
      previous = state.product.variants.find(function (candidate) {
        return String(candidate.id) === String(state.currentVariantId);
      }) || null;
    }

    try {
      root.dispatchEvent(new CustomEvent('variant:changed', {
        bubbles: true,
        detail: { variant: variant, previousVariant: previous }
      }));
      state.currentVariantId = variant.id;
      return true;
    } catch (e) {
      return false;
    }
  }

  function selectGalleryMedia(variant) {
    var mediaId = mediaIdForVariant(variant);
    if (!mediaId) return false;

    var thumb = document.querySelector('.product-gallery__thumbnail[data-media-id="' + CSS.escape(mediaId) + '"]');
    if (thumb) {
      try { thumb.click(); return true; } catch (e) {}
    }

    var cell = document.querySelector('.product-gallery__carousel-item[data-media-id="' + CSS.escape(mediaId) + '"]');
    if (cell) {
      var carousel = cell.closest('.product-gallery__carousel');
      if (carousel && window.jQuery) {
        try {
          var $carousel = window.jQuery(carousel);
          if ($carousel.data('flickity')) {
            $carousel.flickity('selectCell', cell);
            return true;
          }
        } catch (e) {}
      }
    }
    return false;
  }

  function updateCustomLandingImage(variant) {
    var url = imageUrlForVariant(variant);
    if (!url) return false;
    var img = document.querySelector('[id^="mg-woowax-main-"], [id^="mg-watershield-main-"], [id^="mg-activo-main-"], [id^="mg-nova-main-"]');
    if (!img) return false;
    if (img.src !== url) img.src = url;
    if (img.srcset) img.srcset = '';
    return true;
  }

  function syncFromPumperSelect(select) {
    loadProduct().then(function (product) {
      var variant = findVariant(select, product);
      if (!variant) return;

      /* Warehouse's native product section listens for this event and moves Flickity to variant.featured_media. */
      var emitted = emitThemeVariantChanged(variant);

      /* Direct media selection is a non-invasive fallback for unusual product templates. */
      if (!emitted) selectGalleryMedia(variant);
      else window.setTimeout(function () { selectGalleryMedia(variant); }, 0);

      /* Custom MilGenial landings do not instantiate Warehouse ProductSection. */
      updateCustomLandingImage(variant);
    });
  }

  document.addEventListener('change', function (event) {
    var select = event.target && event.target.closest ? event.target.closest('select') : null;
    if (!select || !pumperContainer(select)) return;
    syncFromPumperSelect(select);
  }, false);

  /* Pumper is mounted asynchronously; warm the product JSON without observing/mutating its DOM. */
  if (/\/products\//.test(window.location.pathname)) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', loadProduct, { once: true });
    } else {
      loadProduct();
    }
  }
})();
